import { useEffect, useState } from 'react';
import departmentsApi from '../../../Api/axios/departments-api';

const useDepartments = setIsLoading => {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    departmentsApi
      .readAll()
      .then(response => {
        if (isMounted && response.data) {
          const formattedData = response.data.map(department => [
            department.name,
            department.status ? 'Activo' : 'Inactivo',
            department.id,
          ]);
          setDepartments(formattedData);
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [setIsLoading]);

  return {
    departments,
    setDepartments,
  };
};

export default useDepartments;
